import React, { useEffect } from 'react';
import { Tabs } from 'antd';
import AssetsTab from '../../AdminDashboard/Data/AssetsTab/AssetsTab';
import EquitiesTab from '../../AdminDashboard/Data/Equities';
import OptionsMarkets from './OptionsMarkets';
import OptionsPositions from './OptionsPositions';
import { useDispatch, useSelector } from 'react-redux';
import { selectors } from 'state';
import { LoadingScreen } from 'components';

const OptionsIndex: React.FC = () => {
  const dispatch = useDispatch();
  const player = useSelector(selectors.player);
  const optionChainFetching = useSelector(selectors.optionChainFetching);
  const hasOptions = useSelector(selectors.sessionHasOptions);
  // useEffect(() => {
  //   if (hasOptions) {
  //     dispatch(fetchOptionsInstruments({ player_id: player.id }));
  //   }
  // }, [hasOptions, player.id]);

  if (optionChainFetching) {
    return <LoadingScreen />;
  }
  return (
    <div>
      <Tabs defaultActiveKey="markets">
        <Tabs.TabPane key="markets" tab="Markets">
          <OptionsMarkets />
        </Tabs.TabPane>
        <Tabs.TabPane key="positions" tab="Positions">
          <OptionsPositions />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
export default OptionsIndex;
